export const track = (name, props) =>
  analytics.track(name, {
    currentPageWhenTriggered: document.location.pathname,
    ...props
  });
